import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from 'components/commons/Icon';

import { DEFAULT_LOCALE } from 'utils';
import { MINFIN_DEVELOPMENT } from 'constants/path';
import {
  Wrapper,
  Header,
  Title,
  Button,
  IconWrapper,
  ContentWrapper,
  ContentHeader,
  ContentIconWrapper,
  ContentTitle,
  ContentButton,
} from './styles';

const ActualCurrencyData = ({ isContentLayout }) => {
  const { locale } = useIntl();

  const href =
    locale === DEFAULT_LOCALE ? MINFIN_DEVELOPMENT.RU : MINFIN_DEVELOPMENT.UA;

  if (isContentLayout) {
    return (
      <ContentWrapper>
        <ContentHeader>
          <ContentIconWrapper>
            <Icon name="actualData" />
          </ContentIconWrapper>
          <ContentTitle>
            <FormattedMessage id="actualData.title" />
          </ContentTitle>
        </ContentHeader>
        <ContentButton href={href} type="button" target="_blank">
          Перейти
        </ContentButton>
      </ContentWrapper>
    );
  }

  return (
    <Wrapper>
      <Header>
        <IconWrapper>
          <Icon name="actualData" />
        </IconWrapper>
        <Title>
          <FormattedMessage id="actualData.title" />
        </Title>
      </Header>
      <Button href={href} type="button" target="_blank">
        Перейти
      </Button>
    </Wrapper>
  );
};

ActualCurrencyData.propTypes = {
  isContentLayout: PropTypes.bool,
};

ActualCurrencyData.defaultProps = {
  isContentLayout: false,
};

export default ActualCurrencyData;
